<template>
    
    <div>
    <ul style=" list-style-type: none;padding: 0;">
        <a @click="showSizeGuide=true" href="javascript:void(0);"><li class="m-3 text-secondary">Guide de tailles</li></a>
        <router-link to="/nos-magasins"><li class="m-3 text-secondary">Nos magasins</li></router-link>
        <router-link to="/mentions-legales-cgv"><li class="m-3 text-secondary" style="cursor: pointer;">Mentions légales & CGV</li></router-link>

        <router-link to="/echanges-et-retours-article"><li class="m-3 text-secondary" style="cursor: pointer;">Echanges & retour articles</li></router-link>

        
        <!-- <li class="m-3 text-secondary">Cookies</li> -->
        
    </ul>

    <b-modal v-model="showSizeGuide" 
                title="Guide des Tailles" 
                centered hide-footer  
                title-tag="h5"
                header-close-variant="danger"
                title-class="text-warning"
                size="xl">

                    <SizeGuide /> 

      </b-modal>
    </div>

</template>

<script>

import SizeGuide from "@/components/size-guide.vue"


export default ({
    name: "footer-Info",

    components: {
        SizeGuide
    },

    data() {
    return {

     
      showSizeGuide: false,
    
    }

    
  },
})
</script>


